import { render } from "./EditInventoryPage.vue?vue&type=template&id=4b76cffd"
import script from "./EditInventoryPage.vue?vue&type=script&lang=js"
export * from "./EditInventoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__